export default ({ COLORS }) => ({
  container: {
    padding: '20px 20px 40px',
    textAlign: 'center'
  },
  equalPadding: {
    padding: '20px'
  },
  error: {
    margin: '20px 0 -15px',
    color: COLORS.RED.NORMAL
  }
})
